import { useTranslation } from 'react-i18next';
import styles from './SessionMonitoredBadge.module.scss';

export function SessionMonitoredBadge() {
  const { t } = useTranslation();
  return (
    <div className={styles.sessionMonitoredBadge}>
      <span className={styles.dot} />
      <span className={styles.label}>{t('aiInterview.sessionMonitored')}</span>
    </div>
  );
}
